import { render, staticRenderFns } from "./Page_WindowShop.vue?vue&type=template&id=816e600a&scoped=true&"
import script from "./Page_WindowShop.vue?vue&type=script&lang=js&"
export * from "./Page_WindowShop.vue?vue&type=script&lang=js&"
import style0 from "./Page_WindowShop.vue?vue&type=style&index=0&id=816e600a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816e600a",
  null
  
)

export default component.exports